import React from 'react';
import withAppLayout from '../../hoc/withAppLayout';

import { ChannelContainer } from '../../containers';

const ChannelLayout = () => <ChannelContainer />;

export const Channel = withAppLayout(ChannelLayout);
